import React from "react"
import Text from "@/components/common/Text"
import { getCssSizeValue, getHtmlFromRedactorField, getMapKey } from "@/utils/utils"
import CopyToolTip from "@/components/ToolTip/Variants/CopyToolTip"
import { TOOLTIP_POSITION } from "@/components/ToolTip/BaseToolTip"
import { useNavigatorContext } from "@/components/BranchNavigator/index"
import useInfoData from "@/components/BranchNavigator/Info/useInfoData"
import useCurrentBranchData from "@/hooks/useCurrentBranchData"
import styled from "styled-components"

const Section = styled.div`
	animation: fade-in 0.35s ease-in-out;
	--row-gap: 13px;
	display: flex;
	flex-direction: column;
	//height: fit-content;
	padding: ${getCssSizeValue(40)} var(--local-padding-x);
	row-gap: var(--row-gap);

	.text {
		&:first-of-type {
			margin-bottom: 20px;
		}
	}

	&.hq {
		--row-gap: 10px;

		.text {
			&:not(&.email) {
				font-weight: 400;
			}
		}
	}

	&.contact {
		background-color: ${({ theme }) => theme.colors.platinum};

		.text {
			flex-wrap: wrap;
			align-items: center;

			span {
				padding-left: calc(var(--square-size) * 2);
				flex-basis: 100%;
				font-weight: 400;
			}

			//flex-direction: column;
		}
	}

	&.bank-account {
		height: fit-content;
		color: ${({ theme }) => theme.colors.white};
		background-color: ${({ theme }) => theme.colors.chilliRed};

		.text {
			span.helper {
				font-weight: 400;
			}

			&:not(&:first-of-type) {
				width: 100%;
				padding-bottom: var(--row-gap);
				border-bottom: solid 1px ${({ theme }) => theme.colors.whiteSmoke};
			}
		}
	}
`

const OverflowingContainerText = styled.div`
	color: ${({ theme }) => theme.colors.white} !important;
`

const Sections = ({ data, className = "", branchName = false }) => {
	const branch = useCurrentBranchData()
	const { isTextileCollection } = useNavigatorContext()
	const { headers, bankAccount, overflowingContainerText, address, contactEntities } = useInfoData(data)
	return (
		<>
			<Section className={`section hq ${className} `}>
				{branchName && <Text className="col-desktop-12 typo-borna-07">{branch?.fullName || branch?.name}</Text>}
				<Text className="typo-borna-19">{headers.hq}</Text>
				<Text className="typo-borna-65" dangerouslySetInnerHTML={getHtmlFromRedactorField(address)} />
				{!isTextileCollection && (
					<>
						<Text className="typo-borna-65">{branch.phoneNumber}</Text>
						<Text className="typo-borna-65 email">{branch.email}</Text>
					</>
				)}
			</Section>
			<Section className={`section contact ${className}`}>
				<Text className="typo-borna-19">{headers.contact}</Text>
				{contactEntities.map((entity, index) => {
					return (
						<Text key={getMapKey(entity, index)} className="typo-borna-65 square static">
							{entity?.name}
							<span dangerouslySetInnerHTML={getHtmlFromRedactorField(entity?.info)} />
						</Text>
					)
				})}
			</Section>
			<Section className={`section bank-account ${className}`}>
				<Text className="typo-borna-19">{headers.bankAccount}</Text>
				{bankAccount.title.length > 0 && !isTextileCollection && (
					<>
						<Text className="typo-borna-65">{bankAccount.title}</Text>
						<Text className="typo-borna-65">
							{bankAccount.helper.length > 0 && (
								<>
									<span className="helper">{bankAccount.helper}</span>
									<br />
								</>
							)}
							<CopyToolTip position={TOOLTIP_POSITION.BOTTOM} copyValue={bankAccount.value}>
								{bankAccount.value}
							</CopyToolTip>
						</Text>
					</>
				)}
				{isTextileCollection && (
					<OverflowingContainerText
						className="typo-borna typo-borna-46"
						dangerouslySetInnerHTML={getHtmlFromRedactorField(overflowingContainerText)}
					/>
				)}
			</Section>
		</>
	)
}

export default Sections
